import React, { useState, useEffect } from "react";
import useModal from "hook/useModal";

// css
import "assets/style/elements/color-label.scss";

function Element({ className, color = "green" }) {
  return (
    <>
      <span className={"color-label " + color}></span>
    </>
  );
}

export default Element;
